import React, { useContext } from "react";

import { PageLoadingIndicator } from "src/components/LoadingIndicator";
import { AuthContext } from "src/context/AuthContext";
import { AuthStatus } from "src/context/AuthContext/types";

export const LoadingHandler: React.FCC = ({ children }) => {
  const authState = useContext(AuthContext);
  if (authState.status === AuthStatus.LOADING) {
    return <PageLoadingIndicator />;
  }
  return children;
};
